<template>
    <Modal @cancel="closeModal">
        <ModalCard
            @cancel="closeModal"
            :activeValidate="!!(firstname && lastname && /\S+@\S+\.\S+/.test(email))"
            :headerTitle="$t(`contact.form.title.${contact === undefined ? 'new' : 'edit'}`)"
            @confirm="confirm"
        >
            <div>
                <span>
                    {{ $t('contact.form.subtitle') }}
                </span>
                <TextInput class="input" v-model="firstname" :label="$t('contact.form.firstname')" />
                <TextInput class="input" v-model="lastname" :label="$t('contact.form.lastname')" />
                <TextInput v-if="isPhone" class="input" v-model="phone" :label="$t('contact.form.phone')" />
                <TextInput v-else class="input" v-model="email" :label="$t('contact.form.mail')" />
            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import TextInput from '@/components/ui-components/TextInput.vue';
import { ContactFormState } from '@/models/ContactFormState';

export default defineComponent({
    data(): ContactFormState {
        return {
            firstname: this.contact?.firstname ?? '',
            lastname: this.contact?.lastname ?? '',
            email: this.contact?.email ?? '',
        };
    },
    props: {
        contact: {
            type: Object as PropType<ContactFormState>,
            required: false,
        },
        isPhone: {
            type: Boolean,
            required: true,
        },
    },
    components: { TextInput, Modal, ModalCard },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        confirm() {
            this.$emit('confirm', this.$data);
        },
    },
});
</script>

<style>
.input {
    margin-top: 8px;
}
</style>
